export class QueueViewCheckBoxHelper {

  static areAllRowsChecked(data): boolean {
    return data.length && data.every(row => row.checked);
  }

  static toggleAllSelection(items, shouldBeSelected): void {
    items.forEach(item => {
      item.checked = shouldBeSelected;
    });
  }

  static isAnyRowChecked(items): boolean {
    return items.length && items.some(row => row.checked);
  }
}
